import React, { memo } from 'react';

import Form from 'react-bootstrap/Form';

/**
 * Single-line or multi-line input + soft-character-limit counter and warning.
 * Used for both Title (limit 30, single-line) and Body (limit 150, textarea).
 *
 * The limit is *soft* — the input never hard-blocks. When `value.length > softLimit`,
 * the counter turns red+bold (`word-count__value--over-limit`) and an amber
 * warning ("Text may cut off on user devices") appears beside it. Form validity
 * is gated only on "non-empty after trim" — see NotificationForm handle*Changed.
 *
 * Props
 *   controlId, label, placeholder
 *   as: 'input' (default) | 'textarea'
 *   rows: textarea rows (only used when as='textarea')
 *   value: string
 *   isValid: boolean — controls is-invalid feedback
 *   error: string — invalid-feedback text
 *   onChange: (event) => void
 *   softLimit: number — the soft cap
 *   softLimitWarning: string — i18n copy for the warning
 */
const SoftLimitField = ({
  controlId,
  label,
  placeholder,
  as,
  rows,
  value,
  isValid,
  error,
  onChange,
  softLimit,
  softLimitWarning,
}) => {
  const len = value.length;
  const over = len > softLimit;

  return (
    <Form.Group controlId={controlId}>
      <Form.Label className='notification-compose__field-label'>{label}</Form.Label>
      <Form.Control
        as={as}
        rows={rows}
        isInvalid={!isValid}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      <Form.Control.Feedback type='invalid'>{error}</Form.Control.Feedback>
      <div className='word-count'>
        {over && (
          <span className='word-count__warning'>{softLimitWarning}</span>
        )}
        <span
          className={`word-count__value${over ? ' word-count__value--over-limit' : ''}`}
        >
          {len} / {softLimit}
        </span>
      </div>
    </Form.Group>
  );
};

export default memo(SoftLimitField);
